import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import strings from '../../../../../localization';
import styles from './styles';

interface IRecommendedTooltip {
  size: string;
  fileSizeMB: number;
  format: string;
}

const RecommendedTooltip: FC<IRecommendedTooltip> = ({
  size,
  fileSizeMB,
  format,
}) =>
  (
    <Box>
      <Box sx={styles.tooltipRow}>
        <Typography sx={styles.tooltipLabel}>
          {strings.recommendedSize}
          :
        </Typography>
        <Typography sx={styles.tooltipValue}>{size}</Typography>
      </Box>
      <Box sx={styles.tooltipRow}>
        <Typography sx={styles.tooltipLabel}>
          {strings.formats}
          :
        </Typography>
        <Typography sx={styles.tooltipValue}>{format}</Typography>
      </Box>
      <Box sx={styles.tooltipRow}>
        <Typography sx={styles.tooltipLabel}>
          {strings.maxFileSize}
          :
        </Typography>
        <Typography sx={styles.tooltipValue}>
          {fileSizeMB}
          MB
        </Typography>
      </Box>
    </Box>
  );

export default RecommendedTooltip;
